import { TrainingAnswer } from "./training-course-answer.model";
import { TrainingQuestion } from "./training-course-question.model";
import { TrainingCourseSectionState } from "./training-course-section-state";
import { TrainingSectionType } from "./training-section-type";

export class TrainingCourseSection {
  courseSectionId: number;
  sectionName: string;
  sectionOrder: number;
  sectionType: TrainingSectionType;
  videoUri?: string;
  documentUrl?: string;
  questions?: {
    question: TrainingQuestion,
    answers: TrainingAnswer[],
  }[] = [];
  nextSectionId: number;
  sectionStatus: TrainingCourseSectionState;
  isLastSection = false;

  public deserialize(input: any, index: number): this {
    this.courseSectionId = input.id;
    this.sectionName = input.sectionName;
    this.sectionOrder = index + 1;
    this.sectionType = input.sectionType;

    this.videoUri = input.fileURL;
    this.documentUrl = input.fileName;
    this.sectionStatus = input.statusForWorker;

    this.questions = input.questions
      .filter(question => !question.deleted)
      .sort((a, b) => a.order - b.order) // sort first because we're using the index for order
      .map((questionData, index) => {
        return {
          question: (new TrainingQuestion()).deserialize(questionData, index),
          answers: questionData.answers
            .filter(answer => !answer.deleted)
            .map(answer => (new TrainingAnswer).deserialize(answer))
            .sort(TrainingAnswer.sort),
        };
      });

    return this;
  }

  static sort(a: TrainingCourseSection, b: TrainingCourseSection) : number {
    return a.sectionOrder - b.sectionOrder;
  }

  public setNextSectionId(nextSectionId: number) {
    this.nextSectionId = nextSectionId;
  }

  public setIsLastSection() {
    this.isLastSection = true;
  }
};
